/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CertificateEdgeItem
 */
export interface CertificateEdgeItem {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof CertificateEdgeItem
     */
    said?: string;
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof CertificateEdgeItem
     */
    issueeAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CertificateEdgeItem
     */
    issueeAlias?: string;
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof CertificateEdgeItem
     */
    issuerAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof CertificateEdgeItem
     */
    issuerAlias?: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateEdgeItem
     */
    type?: CertificateEdgeItemTypeEnum;
    /**
     * When the credential was issued in format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof CertificateEdgeItem
     */
    issuedAt?: string;
}


/**
 * @export
 */
export const CertificateEdgeItemTypeEnum = {
    Unknown: 'UNKNOWN',
    Dossier: 'DOSSIER',
    OrgIdentity: 'ORG_IDENTITY',
    Range: 'RANGE',
    Brand: 'BRAND',
    TnAlloc: 'TN_ALLOC',
    DelSig: 'DEL_SIG',
    Qvi: 'QVI',
    Root: 'ROOT',
    A2PCampaign: 'A2P_CAMPAIGN'
} as const;
export type CertificateEdgeItemTypeEnum = typeof CertificateEdgeItemTypeEnum[keyof typeof CertificateEdgeItemTypeEnum];


/**
 * Check if a given object implements the CertificateEdgeItem interface.
 */
export function instanceOfCertificateEdgeItem(value: object): boolean {
    return true;
}

export function CertificateEdgeItemFromJSON(json: any): CertificateEdgeItem {
    return CertificateEdgeItemFromJSONTyped(json, false);
}

export function CertificateEdgeItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CertificateEdgeItem {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
        'issueeAid': json['issueeAid'] == null ? undefined : json['issueeAid'],
        'issueeAlias': json['issueeAlias'] == null ? undefined : json['issueeAlias'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'issuerAlias': json['issuerAlias'] == null ? undefined : json['issuerAlias'],
        'type': json['type'] == null ? undefined : json['type'],
        'issuedAt': json['issuedAt'] == null ? undefined : json['issuedAt'],
    };
}

export function CertificateEdgeItemToJSON(value?: CertificateEdgeItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'issueeAid': value['issueeAid'],
        'issueeAlias': value['issueeAlias'],
        'issuerAid': value['issuerAid'],
        'issuerAlias': value['issuerAlias'],
        'type': value['type'],
        'issuedAt': value['issuedAt'],
    };
}

